import {
  socketConnectionClosed,
  socketConnectionError,
  socketConnectionInit,
  socketConnectionSuccess,
} from 'src/store/Reducer/socket/socketSlice'
import { AppThunk } from 'src/store/store'
import { Errcode } from 'src/constants/errcode'
import { Cmdtypes } from 'src/constants/cmdtypes'
import { commonUtils } from 'src/utils/common.utils'
import { RequestDataType } from 'src/types/websocket'
import SessionStorageUtils from 'src/utils/SessionStorage.utils'
import { eventBus } from 'src/api/eventBus'
import { setLoginStatus } from 'src/store/Reducer/common/commonSlice'

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL
const { getStorageData, updateStorageData, deleteStorageData } = SessionStorageUtils()

const SocketManager = (): AppThunk => {
  return async (dispatch, getState) => {
    const { socket_connected } = getState().socket

    return new Promise((resolve, reject) => {
      if (!socket_connected) {
        const socket = new WebSocket(SOCKET_URL as string)

        dispatch(socketConnectionInit({ socket }))

        socket.onopen = async () => {
          dispatch(socketConnectionSuccess())
          resolve()
        }

        socket.onerror = () => {
          dispatch(socketConnectionError())
          reject('WebSocket connection error')
        }

        socket.onmessage = (event) => {
          dispatch(SocketReceiver(event.data))
        }

        socket.onclose = () => {
          dispatch(socketConnectionClosed())
          deleteStorageData()

          eventBus.publish({ CmdType: Cmdtypes.LOGOUT, responseData: {
            Header: {
              CmdType: Cmdtypes.LOGOUT,
              ErrCode: Errcode.SUCCESS,
              ErrMsg: ''
            },
            Body: null
          }})
        }
      } else return
    })
  }
}

const SocketReceiver = (resData: string): AppThunk => {
  return async (dispatch) => {
    const parseData = JSON.parse(resData)
    const { Header } = parseData
    switch (Header.ErrCode) {
      case Errcode.SESSION_ERROR:
      case Errcode.INTERNAL_ERROR:
        deleteStorageData()
        getStorageData('errorModalMsg') === '' &&
          updateStorageData('errorModalMsg', Header.ErrMsg as string)
        dispatch(setLoginStatus(false))
        break
      default:
        eventBus.publish({ CmdType: Header.CmdType, responseData: parseData })
        break
    }
  }
}

const SocketSender = <T>(CmdType: Cmdtypes, Body?: T): AppThunk => {
  return async (_dispatch, getState) => {
    CmdType === Cmdtypes.LOGIN && updateStorageData('RequestId', commonUtils.getRequestID())
    const { socket } = getState().socket

    const RequestData: RequestDataType<T | undefined> = {
      Header: {
        CmdType: CmdType,
        RequestID: getStorageData('RequestId'),
        Language: navigator.language.toLowerCase(),
      },
      Body: Body,
    }
    if (
      socket &&
      socket.readyState === WebSocket.OPEN &&
      getStorageData('userInfo').Email !== 'test'
    ) {
      socket.send(JSON.stringify(RequestData))
    } else if (socket !== null) {
      SocketCloser()
    } else {
      console.warn(CmdType, 'Socket is not open.')
    }
  }
}

const SocketCloser = (): AppThunk => {
  return async (_dispatch, getState) => {
    const { socket } = getState().socket

    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.close()
    }
    eventBus.publish({ CmdType: Cmdtypes.LOGOUT, responseData: {
      Header: {
        CmdType: Cmdtypes.LOGOUT,
        ErrCode: Errcode.SUCCESS,
        ErrMsg: ''
      },
      Body: null
    }})
  }
}

export { SocketManager, SocketReceiver, SocketSender, SocketCloser }
